const traning_qualification_routes = {
      path: "/qualificationInquire",
      name: "QualificationInquire",
      component: () => import("@/components/LayOut/Main"),
      meta: {requiresAuth: true},
      children: [
        {
          path: "home",
          component: () => import('@/views/training_qualification/Home'),
          meta: {requiresAuth: true},
        },
        /* 学员管理 */
        {
          path: "stu",
          component: () => import("@/views/system_manager/student/stu-student"),
          meta: {requiresAuth: true}
        },
        /* 学员培训历程 */
        {
          path: "st",
          component: () => import("@/views/system_manager/student/stu-train"),
          meta: {requiresAuth: true}
        },
        {
          path: "tea_sd",
          component: () => import('@/views/training_teacher/stu-detail'),
          meta: {requiresAuth: true},
        },
        // 查看某个学员的学习详情
        {
          path: "student_study_learn_view",
          component: () => import("@/views/system_manager/education/studentStudyLearnView"),
          meta: {requiresAuth: true}
        },
        /* 处罚详情 */
        {
          path:"punishResultInfo",
          component :() => import('@/views/punishPeople/punishResultInfo'),
          meta: {requiresAuth: true},
        },
        /* 处罚申请详情 */
        {
          path:"punishApply",
          component :() => import('@/views/punishPeople/punishApplyInfo'),
          meta: {requiresAuth: true},
        },
        /* 资格审核的一条记录 */
        {
          path:"record",
          component :() => import('@/views/system_manager/review/record'),
          meta: {requiresAuth: true},
        },
        {
          path: "coach_score",
          component: () => import("@/views/system_manager/score/coach-score"),
          meta: {requiresAuth: true}
        },
      ]
    }

export default traning_qualification_routes;
